// extracted by mini-css-extract-plugin
export default {"lastEditInfoContainer":"MarkdownLastEditedBy-module__lastEditInfoContainer--EN_Qz","mutedEditorLink":"MarkdownLastEditedBy-module__mutedEditorLink--pD3Z6"};